export default "__VITE_ASSET__ZY5bnPUR__"